<template>
  <v-row
    align-content="center"
    justify="center"
    class="mt-5 ml-3"
    v-if="documentsToPreview.length && documentsToPreview.length >= 2"
  >
    <v-col
      class="pt-0 px-5"
      cols="12"
      md="6"
      sm="12"
      v-for="(document, index) in wrappedDocumentsToPreview"
      :key="index"
    >
      <label v-if="!onlyReadContract" for=""
        >Seleccionar documento para comparar</label
      >
      <v-autocomplete
        :disabled="onlyReadContract"
        v-model="formDocumentPreview[`document_${index}`]"
        :items="folderSaleResidentialSctructure"
        item-text="document_type.name"
        @change="changeDocumentToPreview(index, $event)"
        item-value="id"
        searchable
        class="mt-0 pt-0 mb-3"
        placeholder="Seleccionar documentos"
      ></v-autocomplete>
      <h4
        class="text-center mb-5"
        v-if="document.extension !== 'pdf' && document.extension !== 'docx'"
      >
        {{ document.document_type.name }}
      </h4>
      <component
        :key="!index ? keyLeft + index : keyRight + index"
        id="previewDocument"
        :is="document.component"
        style="width: 96%;"
        :src="document.url"
        :title="document.document_type.name"
        controls
      />
    </v-col>
  </v-row>
  <h6 v-else class="text-center mt-8">
    Debes cargar al menos 2 documentos para comparar
  </h6>
</template>

<script>
import { mapGetters } from "vuex";
import PDFViewer from "@/components/commons/filePreview/PdfViewer.vue";
import DocxViewer from "@/components/commons/filePreview/DocxViewer.vue";
import {
  NAME_FOLDER_SALE_RESIDENTIAL,
  NAME_FILE_CONTRACT,
  NAME_FILE_IDENTITY_CARD,
} from "@/constants/presale";

export default {
  props: {
    onlyReadContract: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PDFViewer,
    DocxViewer,
  },
  data() {
    return {
      keyLeft: 1000,
      keyRight: 1000,
      documentsToPreview: [],
      formDocumentPreview: {
        document_0: null,
        document_1: null,
      },
    };
  },
  methods: {
    resetDocumentsToPreview() {
      this.documentsToPreview = [];
    },
    setDocumentsToCompare(documentsToCompare) {
      this.documentsToPreview = documentsToCompare;
      this.formDocumentPreview.document_0 = documentsToCompare[0]?.id;
      this.formDocumentPreview.document_1 = documentsToCompare[1]?.id;
    },
    changeDocumentToPreview(index, item) {
      this.$set(
        this.documentsToPreview,
        index,
        this.folderSaleResidentialSctructure.find(
          (document) => document.id == item
        )
      );
      index === 0 ? (this.keyLeft += 1) : (this.keyRight += 1);
    },
  },
  computed: {
    ...mapGetters({
      documents: "document/documents",
    }),
    wrappedDocumentsToPreview: {
      get() {
        return this.documentsToPreview.map((document) => {
          return {
            ...document,
            url: document.documents[0].url,
            extension: document.documents[0].extension,
            component:
              document.documents[0].extension === "pdf"
                ? "PDFViewer"
                : document.documents[0].extension === "docx"
                ? "DocxViewer"
                : "img",
          };
        });
      },
    },
    folderSaleResidentialSctructure() {
      return this.documents.length
        ? this.documents[0].children
            .find((folder) => folder.name == NAME_FOLDER_SALE_RESIDENTIAL)
            ?.folder_document_types.filter(
              (document_type) => document_type.documents.length
            )
            .sort((a, b) =>
              a.document_type.name == NAME_FILE_CONTRACT
                ? -1
                : b.document_type.name == NAME_FILE_CONTRACT
                ? 1
                : a.document_type.name == NAME_FILE_IDENTITY_CARD
                ? -1
                : b.document_type.name == NAME_FILE_IDENTITY_CARD
                ? 1
                : 0
            )
        : [];
    },
  },
};
</script>

<style></style>
